module.exports = __webpack_public_path__ + "img/hr-tree-06-j-leaves.1cf9f8d3.png";